import React from 'react'
import { useTranslation } from 'react-i18next'
import AnalyticSeriesChart, {
    AnalyticSeriesData,
} from '../../../shared/AnalyticSeriesChart'

interface JobsChartProps {
    data?: AnalyticSeriesData
}

// Number of concurrent live-stream jobs (raw count). Single-metric time series
// from the margarita-backed endpoint (type=/no_of_live_jobs); total = MAX.
const JobsChart: React.FC<JobsChartProps> = ({ data }) => {
    const { t } = useTranslation()
    return (
        <AnalyticSeriesChart
            data={data}
            title={t('services.no-of-live-jobs')}
            unit="jobs"
            color="#2563eb"
            variant="bar"
            totalLabel="Peak Jobs"
            hideStats
            emptyText="No job data available for the selected period"
        />
    )
}

export default JobsChart
